import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import "./DashboardLayout.css"

export default function DashboardLayout() {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="main-content">
        <Outlet /> {/* هنا هتظهر الصفحات */}
      </main>
    </div>
  );
}